
const TableViewAdminPage = ({loading, tasks, setSelectedTask, setOpenReassign}) => {
  return (
    <>
                <div className="overflow-x-auto">
                    <table
                        className="
                            min-w-full
                            divide-y
                            divide-gray-50 text-sm
                        "
                    >
                        {/* HEAD */}
                        <thead className="bg-gradient-to-r from-gray-50 to-gray-100">
                            <tr>
                                <th className="px-1 py-4 text-left border border-gray-300">
                                    taskid
                                </th>
                                <th className="px-1 py-4 text-left border border-gray-300">
                                    source_file
                                </th>
                                {/* <th className="px-1 py-4 text-left border border-gray-300">
                                    target_file
                                </th> */}
                                <th className="px-1 py-4 text-left border border-gray-300">
                                    Assigned To
                                </th>
                                <th className="px-1 py-4 text-left border border-gray-300">
                                    Status
                                </th>
                                <th className="px-1 py-4 text-left border border-gray-300">
                                    Action
                                </th>
                            </tr>
                        </thead>


                        {/* BODY */}
                        <tbody
                            className="
                                divide-y
                                divide-gray-100
                                bg-white
                            "
                        >

                            {loading ? (

                                <tr>
                                    <td
                                        colSpan={5}
                                        className="
                                            text-center
                                            py-10
                                            text-gray-500
                                        "
                                    >
                                        Loading tasks...
                                    </td>
                                </tr>

                            ) : Array.isArray(
                                tasks
                            ) &&
                                tasks.length > 0 ? (

                                tasks.map((task) => (

                                    <tr
                                        key={task.id}
                                        className="hover:bg-indigo-50 transition"
                                    >

                                        {/* TASK */}
                                        <td className="p-1 py-2 break-words text-x border border-gray-300">

                                            <div className="font-semibold text-gray-800">
                                                {
                                                    task.taskid
                                                }
                                            </div>

                                        </td>

                                        <td className="p-1 py-2 break-words text-x border border-gray-300">

                                            <span
                                                className="
                                                    px-3
                                                    py-1
                                                    rounded-full
                                                    bg-blue-100
                                                    text-blue-700
                                                    text-sm
                                                "
                                            >
                                                {task.source_file} ({task.source_lang}-{task.target_lang})
                                            </span>
                                        </td>

                                        {/* <td className="p-1 py-2 break-words text-x border border-gray-300">
                                            <div className="font-medium text-gray-700">
                                                {
                                                    task.target_file
                                                }
                                            </div>
                                        </td> */}
                                        <td className="p-1 py-2 break-words text-x border border-gray-300">
                                            <div className="font-medium text-gray-700">
                                                {
                                                    task.assigned_to
                                                }
                                            </div>
                                        </td>

                                        {/* STATUS */}
                                        <td className="p-1 py-2 break-words text-x border border-gray-300">

                                            <span
                                                className={`
                                                    px-3
                                                    py-1
                                                    rounded-full
                                                    text-sm
                                                    font-medium

                                                    ${task.status ===
                                                        "completed"
                                                        ? "bg-green-100 text-green-700"
                                                        : task.status ===
                                                            "in_progress"
                                                            ? "bg-yellow-100 text-yellow-700"
                                                            : "bg-red-100 text-red-700"
                                                    }
                                                `}
                                            >
                                                {
                                                    task.status
                                                }
                                            </span>
                                        </td>


                                        {/* ACTION */}
                                        <td className="p-1 py-2 break-words text-x border border-gray-300">
                                            <button
                                                onClick={() => {

                                                    setSelectedTask(
                                                        task
                                                    );

                                                    setOpenReassign(
                                                        true
                                                    );
                                                }}
                                                className="
                                                    bg-indigo-600
                                                    hover:bg-indigo-700
                                                    text-white
                                                    px-3
                                                    py-2
                                                    rounded-xl
                                                    shadow-sm
                                                    transition
                                                "
                                            >
                                                Reassign
                                            </button>
                                        </td>
                                    </tr>
                                ))

                            ) : (

                                <tr>
                                    <td
                                        colSpan={5}
                                        className="
                                            text-center
                                            py-12
                                            text-gray-400
                                        "
                                    >
                                        No tasks found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
            </div>
           
    </>

)}

export default TableViewAdminPage;